import React from 'react';
import { DropDownMultipleSelect } from './common';
import {validatable} from 'components/utils';

class DropDownChonLinhVucThanhTraMultiple extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDownMultipleSelect
        label={this.props.label }
        bindValidator={this}
        channel="formTaoDon"
        require={this.props.require}
        value={this.props.selectedValue}
        options={ this.props.data }
        onChange={ this.onChange.bind(this) }
        placeholder={ this.props.placeholder }
        closeMenuOnSelect={false}
        className={this.props.className}
        validLinhVucThanhTra={this.props.validLinhVucThanhTra}
      />
    );
  }
}

DropDownChonLinhVucThanhTraMultiple.defaultProps = {
  label: 'Lĩnh vực thanh tra',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [
    {giaTri: 'Hành chính', ten: 'Hành chính'},
    {giaTri: 'Đất đai', ten: 'Đất đai'},
    {giaTri: 'XDCB', ten: 'XDCB'},
    {giaTri: 'Chuyên ngành', ten: 'Chuyên ngành'}
  ],
  className: '',
  validLinhVucThanhTra: true
}

export default validatable(DropDownChonLinhVucThanhTraMultiple);


// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownChonLinhVucThanhTraMultiple.jsx